module.exports = __webpack_public_path__ + "img/todo_4.b8ccf453.png";